module.exports = __webpack_public_path__ + "static/media/logo.d31375d3.png";